////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const tagsManager = {
	getTags: () => ({
		type: ActionsTypes.GET_TAGS,
	}),
	getTagsSuccess: (tags) => ({
		type: ActionsTypes.GET_TAGS_SUCCESS,
		payload: {
			tags,
		},
	}),
	getTagsFailure: (error) => ({
		type: ActionsTypes.GET_TAGS_FAILURE,
		payload: {
			error,
		},
	}),
	createTag: (tag) => ({
		type: ActionsTypes.CREATE_TAG,
		payload: {
			tag,
		},
	}),
	createTagSuccess: (tag) => ({
		type: ActionsTypes.CREATE_TAG_SUCCESS,
		payload: {
			tag,
		},
	}),
	createTagFailure: (error) => ({
		type: ActionsTypes.CREATE_TAG_FAILURE,
		payload: {
			error,
		},
	}),
	getTagDetail: (tagList, requestType) => ({
		type: ActionsTypes.GET_TAG_DETAIL,
		payload: { tagList, requestType },
	}),
	getTagDetailSuccess: (list, typeList) => ({
		type: ActionsTypes.GET_TAG_DETAIL_SUCCESS,
		payload: {
			list,
			typeList,
		},
	}),
	getTagDetailFailure: (error) => ({
		type: ActionsTypes.GET_TAG_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),
	resetTag: () => ({
		type: ActionsTypes.RESET_TAG,
	}),
	resetTagDetail: () => ({
		type: ActionsTypes.RESET_TAG_DETAIL,
	}),
	deleteTag: (idTag) => ({
		type: ActionsTypes.DELETE_TAG,
		payload: {
			idTag,
		},
	}),
	deleteTagSuccess: (idTag) => ({
		type: ActionsTypes.DELETE_TAG_SUCCESS,
		payload: {
			idTag,
		},
	}),
	deleteTagFailure: (error) => ({
		type: ActionsTypes.DELETE_TAG_FAILURE,
		payload: {
			error,
		},
	}),
	updateTagHeader: (idTag, tag) => ({
		type: ActionsTypes.UPDATE_TAG_HEADER,
		payload: {
			idTag,
			tag,
		},
	}),
	updateTagHeaderSuccess: (tag) => ({
		type: ActionsTypes.UPDATE_TAG_HEADER_SUCCESS,
		payload: {
			tag,
		},
	}),
	updateTagHeaderFailure: (error) => ({
		type: ActionsTypes.UPDATE_TAG_HEADER_FAILURE,
		payload: {
			error,
		},
	}),
	updateTagContent: (datas, type) => ({
		type: ActionsTypes.UPDATE_TAG_CONTENT,
		payload: {
			datas,
			type,
		},
	}),
	updateTagContentSuccess: (tags, type, sentData) => ({
		type: ActionsTypes.UPDATE_TAG_CONTENT_SUCCESS,
		payload: {
			tags,
			type,
			sentData,
		},
	}),
	updateTagContentFailure: (error) => ({
		type: ActionsTypes.UPDATE_TAG_CONTENT_FAILURE,
		payload: {
			error,
		},
	}),
}

export default tagsManager
